import { Box, Button, Typography } from '@mui/material';
import { MAIN_THEME_COLOR } from '../assets/theme/Colors';

function AlertBanner({
	btnOneTxt,
	btnTwoTxt,
	handleButtonOneClick,
	handleButtonTwoClick,
	content,
	displayBtnOne = false,
	displayBtnTwo = false,
}) {
	return (
		<Box
			sx={{
				width: '100%',
				display: 'flex',
				flexDirection: 'row',
				backgroundColor: '#FFFFFF',
				paddingY: '6px',
				paddingX: '10px',
				alignItems: 'center',
				justifyContent: 'space-between',
			}}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					marginX: '10px',
				}}>
				<Typography variant="body2" sx={{ color: MAIN_THEME_COLOR }}>
					{content}
				</Typography>
			</Box>
			<Box>
				<>
					{displayBtnOne && (
						<Button
							onClick={handleButtonOneClick}
							style={{
								boxShadow: 'none',
								textTransform: 'none',
								backgroundColor: MAIN_THEME_COLOR,
								color: '#FFFFFF',
								marginLeft: '10px',
							}}
							variant="contained">
							{btnOneTxt}
						</Button>
					)}
					{displayBtnTwo && (
						<Button
							onClick={handleButtonTwoClick}
							style={{
								boxShadow: 'none',
								textTransform: 'none',
								backgroundColor: MAIN_THEME_COLOR,
								color: '#FFFFFF',
								marginLeft: '10px',
							}}
							variant="contained">
							{btnTwoTxt}
						</Button>
					)}
				</>
			</Box>
		</Box>
	);
}

export default AlertBanner;
